import { Grid, Button, Popconfirm, Row } from "antd";
import DeleteImage from "../../assets/Delete.png";
import { RequestListingApplicationModal } from "../RequestListingApplicationModal";
import { useState } from "react";
import { useMobxStores } from "../../stores/stores";
import { observer } from "mobx-react";
import { CreateListingModal } from "../Requests/CreateListingModal";
const { useBreakpoint } = Grid;

const RequestItemDetailsFooter = ({ requestId, isRequestListingOwner }) => {
  const { requestsStore } = useMobxStores();
  const [showApplicationModal, setShowApplicationModal] = useState(false);
  const [showCreateListingModal, setShowCreateListingModal] = useState(false);
  const screens = useBreakpoint();
  const isMobile = !screens.sm; // < md = mobile

  const handleDeleteRequestListing = async () => {
    await requestsStore.DeleteRequestListingById(requestId);
  };

  return (
    <>
      {isMobile ? (
        <>
          {" "}
          {isRequestListingOwner &&
            requestsStore.requestListing?.requests.length > 0 && (
              <div>
                <div className="request-details-text">Applicants</div>
                <div className="applicants-container">
                  <div className="applicants-columns">
                    <div className="applicant-names">
                      {requestsStore.requestListing?.requests?.map(
                        (request) => (
                          <>
                            <div
                              style={{
                                width: "200px",
                              }}
                              key={request.id}
                              className="applicant-username-text"
                            >
                              {request.applicant_username}
                            </div>
                            <div
                              key={request.id}
                              className="applicant-buttons-container"
                            >
                              {request.status.toLowerCase() === "pending" ? (
                                <>
                                  <Button
                                    type="primary"
                                    className="share-contact-button"
                                    onClick={() =>
                                      requestsStore.PatchRequest(request.id, {
                                        status: "Accepted",
                                      })
                                    }
                                  >
                                    Share contact
                                  </Button>
                                  <Button
                                    type="primary"
                                    className="reject-contact-button"
                                    onClick={() =>
                                      requestsStore.PatchRequest(request.id, {
                                        status: "Rejected",
                                      })
                                    }
                                  >
                                    Reject
                                  </Button>
                                </>
                              ) : request.status.toLowerCase() ===
                                "accepted" ? (
                                <div className="contact-shared-button">
                                  Contact shared
                                </div>
                              ) : (
                                <div className="contact-rejected-button">
                                  Rejected
                                </div>
                              )}
                            </div>
                          </>
                        )
                      )}
                    </div>

                    {/* <div className="applicant-buttons">
                      {requestsStore.requestListing?.requests?.map(
                        (request) => (
                          <div
                            key={request.id}
                            className="applicant-buttons-container"
                          >
                            {request.status.toLowerCase() === "pending" ? (
                              <>
                                <Button
                                  type="primary"
                                  className="share-contact-button"
                                  onClick={() =>
                                    requestsStore.PatchRequest(request.id, {
                                      status: "Accepted",
                                    })
                                  }
                                >
                                  Share contact
                                </Button>
                                <Button
                                  type="primary"
                                  className="reject-contact-button"
                                  onClick={() =>
                                    requestsStore.PatchRequest(request.id, {
                                      status: "Rejected",
                                    })
                                  }
                                >
                                  Reject
                                </Button>
                              </>
                            ) : request.status.toLowerCase() === "accepted" ? (
                              <div className="contact-shared-button">
                                Contact shared
                              </div>
                            ) : (
                              <div className="contact-rejected-button">
                                Rejected
                              </div>
                            )}
                          </div>
                        )
                      )}
                    </div> */}
                    <div className="divider" />
                  </div>
                </div>
              </div>
            )}
          {isRequestListingOwner ? (
            <>
              <Button
                className="request-details-edit-button"
                type="primary"
                onClick={() => setShowCreateListingModal(true)}
              >
                Edit
              </Button>
              <CreateListingModal
                showCreateListingModal={showCreateListingModal}
                setShowCreateListingModal={setShowCreateListingModal}
                defaultValues={requestsStore.requestListing}
                isUpdating={true}
              />
              <Popconfirm
                title="Are you sure you want to delete this item?"
                onConfirm={() => handleDeleteRequestListing()}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  className="request-details-delete-button"
                  type="primary"
                  shape="circle"
                  style={{
                    border: "none",
                    padding: 0,
                    width: "auto",
                    height: "auto",
                    lineHeight: 0,
                  }}
                  icon={
                    <img
                      className="delete_applicants"
                      src={DeleteImage}
                      alt="delete"
                      style={{
                        width: "40px",
                        height: "40px",
                        display: "block",
                      }}
                    />
                  }
                />
              </Popconfirm>
            </>
          ) : (
            <Row>
              <Button
                className="request-details-apply-button"
                type="primary"
                disabled={
                  requestsStore.requestListing.status.toLowerCase() ===
                  "completed"
                }
                onClick={() => setShowApplicationModal(true)}
              >
                Apply to contact
              </Button>
              <RequestListingApplicationModal
                showApplicationModal={showApplicationModal}
                setShowApplicationModal={setShowApplicationModal}
                requestId={requestsStore.requestListing?.id}
              />
            </Row>
          )}
        </>
      ) : (
        <>
          {" "}
          {isRequestListingOwner &&
            requestsStore.requestListing?.requests.length > 0 && (
              <div>
                <div className="request-details-text">Applicants</div>
                <div className="applicants-container">
                  <div className="applicants-columns">
                    <div className="applicant-names">
                      {requestsStore.requestListing?.requests?.map(
                        (request) => (
                          <div
                            key={request.id}
                            className="applicant-username-text"
                          >
                            {request.applicant_username}
                          </div>
                        )
                      )}
                    </div>
                    <div className="vertical-divider" />
                    <div className="applicant-buttons">
                      {requestsStore.requestListing?.requests?.map(
                        (request) => (
                          <div
                            key={request.id}
                            className="applicant-buttons-container"
                          >
                            {request.status.toLowerCase() === "pending" ? (
                              <>
                                <Button
                                  type="primary"
                                  className="share-contact-button"
                                  onClick={() =>
                                    requestsStore.PatchRequest(request.id, {
                                      status: "Accepted",
                                    })
                                  }
                                >
                                  Share contact
                                </Button>
                                <Button
                                  type="primary"
                                  className="reject-contact-button"
                                  onClick={() =>
                                    requestsStore.PatchRequest(request.id, {
                                      status: "Rejected",
                                    })
                                  }
                                >
                                  Reject
                                </Button>
                              </>
                            ) : request.status.toLowerCase() === "accepted" ? (
                              <div className="contact-shared-button">
                                Contact shared
                              </div>
                            ) : (
                              <div className="contact-rejected-button">
                                Rejected
                              </div>
                            )}
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          {isRequestListingOwner ? (
            <>
              <Button
                className="request-details-edit-button"
                type="primary"
                onClick={() => setShowCreateListingModal(true)}
              >
                Edit
              </Button>
              <CreateListingModal
                showCreateListingModal={showCreateListingModal}
                setShowCreateListingModal={setShowCreateListingModal}
                defaultValues={requestsStore.requestListing}
                isUpdating={true}
              />
              <Popconfirm
                title="Are you sure you want to delete this item?"
                onConfirm={() => handleDeleteRequestListing()}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  className="request-details-delete-button"
                  type="primary"
                  shape="circle"
                  style={{
                    border: "none",
                    padding: 0,
                    width: "auto",
                    height: "auto",
                    lineHeight: 0,
                  }}
                  icon={
                    <img
                      className="delete_applicants"
                      src={DeleteImage}
                      alt="delete"
                      style={{
                        width: "40px",
                        height: "40px",
                        display: "block",
                      }}
                    />
                  }
                />
              </Popconfirm>
            </>
          ) : (
            <Row>
              <Button
                className="request-details-apply-button"
                type="primary"
                disabled={
                  requestsStore.requestListing.status.toLowerCase() ===
                  "completed"
                }
                onClick={() => setShowApplicationModal(true)}
              >
                Apply to contact
              </Button>
              <RequestListingApplicationModal
                showApplicationModal={showApplicationModal}
                setShowApplicationModal={setShowApplicationModal}
                requestId={requestsStore.requestListing?.id}
              />
            </Row>
          )}
        </>
      )}
    </>
  );
};

export default observer(RequestItemDetailsFooter);
